import { IAddress } from '@commenda/types';

export interface UKActivity {
  ukVATRegistrationReasons?: string[];
  ukActivityDescription?: string;
  goodsStoredOrShippedFromUK?: boolean;
  ukGoodProviders?: { name: string; address: IAddress }[];
  hasUKExemptSupplies?: string;
  ukPresenceTypes?: string[];
  ukPresenceDetails?: string;
  directorsInvolvedInOtherUKBusiness?: boolean;
  otherUKBusinessesDetails?: string;
}

export interface IndirectTaxRegistrationValue {
  contentRegistrationId?: string;
  registrationTaxTypeId?: string;
  taxTypes?: string[];
  frequency?: string;
  effectiveStartDate?: string;
  portalId?: string;
  registrationFields?: Record<string, string>;
  credentialFields?: Record<string, string>;
  createdTaxRegistrationId?: string;
  jurisdictionRegion?: string;
  intraCommunityTrade?: boolean;
  importsOrExportsGoods?: boolean;
  ukActivity?: UKActivity;
}

export const DEFAULT_JURISDICTION_CONTEXT_KEY = 'jurisdictionId';

export interface IndirectTaxRegistrationConfig {
  jurisdictionContextKey?: string;
  newRegistration?: {
    responsiblePartyFieldId?: string;
    effectiveStartDateFieldId?: string;
    firstYearTaxableSaleFieldId?: string;
    bankAccountFieldId?: string;
    reasonForNonUKBankAccountFieldId?: string;
  };
}
